"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncDescriptor = void 0;
var util_1 = require("./util");
var SyncDescriptor = /** @class */ (function () {
    function SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation, supportsOverride) {
        if (staticArguments === void 0) { staticArguments = []; }
        if (supportsDelayedInstantiation === void 0) { supportsDelayedInstantiation = false; }
        if (supportsOverride === void 0) { supportsOverride = false; }
        this.ctor = ctor;
        this.staticArguments = staticArguments;
        this.supportsDelayedInstantiation = supportsDelayedInstantiation;
        this.supportsOverride = supportsOverride;
    }
    SyncDescriptor.prototype.isEqualWith = function (descriptor) {
        if (this.ctor !== descriptor.ctor) {
            return false;
        }
        if (this.supportsDelayedInstantiation !== descriptor.supportsDelayedInstantiation) {
            return false;
        }
        if (this.supportsOverride !== descriptor.supportsOverride) {
            return false;
        }
        if (!util_1.arrayEquals(this.staticArguments, descriptor.staticArguments)) {
            return false;
        }
        return true;
    };
    return SyncDescriptor;
}());
exports.SyncDescriptor = SyncDescriptor;
//# sourceMappingURL=descriptors.js.map